export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBUV_Fawg-jMecuuGV8RPcbytrCBvUa88c",
    authDomain: "accuriatools-627ef.firebaseapp.com",
    databaseURL: "https://accuriatools-627ef.firebaseio.com",
    projectId: "accuriatools-627ef",
    storageBucket: "accuriatools-627ef.appspot.com",
    messagingSenderId: "426298319742",
    appId: "1:426298319742:web:bd8b38266ab1e6beca492f",
    measurementId: "G-N0ZGW19D43"
  }
};
